import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API_URL from '../config/api';

const Logout: React.FC = () => {
  const navigate = useNavigate();

  const auth = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const token = auth.token;
        if (token) {
          await fetch(`${API_URL}/auth/logout`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            credentials: 'include'
          });
        }
      } catch (err) {
        // ignore network errors — still clear client session
        console.warn('Logout request failed', err);
      } finally {
        auth.logout();
        navigate('/login');
      }
    })();
  }, [navigate, auth]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh', color: '#6b7280' }}>
      Signing out…
    </div>
  );
};

export default Logout;
